// styles
import '@/assets/scss/index.scss'

import { CreateElement } from 'vue/types/umd'

import Vue from 'vue'

// Sentry
// import * as Sentry from '@sentry/vue'
// import { BrowserTracing } from '@sentry/tracing'

import App from './App.vue'

import { createStore } from '@/store'
import { createRouter } from '@/router'
import { logout } from '@/helpers/logout'

// Plugins
import { initPlugins } from '@/plugins'

Vue.config.productionTip = false
// Vue.config.performance = process.env.NODE_ENV !== 'production'

const store = createStore()
const router = createRouter({ logout, store })
store.$router = router

const app = {
  name: 'root',
  store,
  router,
  render: (h: CreateElement) => h(App),
}

initPlugins({
  Vue,
  app,
  store,
  router,
  logout,
})

// Sentry.init({
//   Vue,
//   dsn: process.env.VUE_APP_SENTRY_DSN,
//   environment: process.env.NODE_ENV,
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: [process.env.VUE_APP_SENTRY_TRACING_ORIGINS, /^\//],
//     }),
//   ],
//   tracesSampleRate: process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE,
// })

new Vue(app).$mount('#app')
